import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(!localStorage.getItem("nj_cookies")); }, []);
  useEffect(() => {
    const h = () => setShow(true);
    window.addEventListener("nj-cookies-manage", h);
    return () => window.removeEventListener("nj-cookies-manage", h);
  }, []);
  if (!show) return null;
  const accept = () => {
    localStorage.setItem("nj_cookies", "1");
    setShow(false);
    window.dispatchEvent(new Event("nj-cookies-accepted"));
    window.dispatchEvent(new Event("nj-cookies-set"));
  };
  const decline = () => {
    localStorage.setItem("nj_cookies", "refused");
    setShow(false);
    window.dispatchEvent(new Event("nj-cookies-set"));
  };
  return (
    <div data-testid="cookie-consent" className="fixed bottom-4 inset-x-4 md:right-auto md:left-6 md:max-w-md z-50 bg-white border border-nj-olive shadow-xl rounded-md p-5">
      <p className="text-sm text-nj-text2 leading-relaxed">
        Nous utilisons des cookies pour améliorer votre expérience et mesurer notre audience.
        En poursuivant, vous acceptez notre politique de cookies.
      </p>
      <div className="flex gap-3 mt-4">
        <Button data-testid="cookie-accept" onClick={accept} className="bg-nj-primary hover:bg-nj-primaryHover text-white rounded-sm">Accepter</Button>
        <Button data-testid="cookie-decline" onClick={decline} variant="outline" className="rounded-sm border-nj-olive">Refuser</Button>
      </div>
    </div>
  );
}
